export class Utilities {
  public getCaptureFormItem<T = HTMLDivElement>(formName: string, fieldName: string): T | null {
    return document.getElementById("capture_" + formName + "_form_item_" + fieldName) as T | null;
  }

  public getCaptureFormBirthdayValue(formName: string) {
    const daySelect = document.getElementById("capture_" + formName + "_birthday_dateselectday") as HTMLSelectElement;
    const monthSelect = document.getElementById("capture_" + formName + "_birthday_dateselectmonth") as HTMLSelectElement;
    const yearSelect = document.getElementById("capture_" + formName + "_birthday_dateselectyear") as HTMLSelectElement;

    if (!yearSelect || !monthSelect || !daySelect) {
      return null;
    }

    const yearValue = yearSelect.options[yearSelect.selectedIndex].value;
    const monthValue = monthSelect.options[monthSelect.selectedIndex].value;
    const dayValue = daySelect.options[daySelect.selectedIndex].value;

    if (!yearValue || !monthValue || !dayValue) {
      return null;
    }

    return `${yearValue}-${monthValue}-${dayValue}`;
  }

  public getCaptureField<T = HTMLInputElement>(formName: string, fieldName: string): T | null {
    return document.getElementById("capture_" + formName + "_" + fieldName) as T | null;
  }

  public getParameterByName(name: string) {
    name = name.replace(/\[/, "\\[").replace(/]/, "\\]");
    const regex = new RegExp("[\\?&]" + name + "=([^&#]*)");
    const results = regex.exec(location.search);
    return results === null ? "" : decodeURIComponent(results[1].replace(/\+/g, " "));
  }

  public parseQuery(queryString: string) {
    const query = {};
    const pairs = (queryString[0] === "?" ? queryString.substr(1) : queryString).split("&");
    for (const element of pairs) {
      const pair = element.split("=");
      query[decodeURIComponent(pair[0])] = decodeURIComponent(pair[1] || "");
    }
    return query;
  }

  public isOnPage(path: string) {
    const pathArray = path.split("?");

    const pathname = pathArray[0];
    const currentPathName = window.location.pathname.replace("/", "");

    const regex = new RegExp("^" + pathname.split("*").join(".*") + "$");
    if (pathname.length !== 0 && !regex.test(currentPathName)) {
      return false;
    }

    if (pathArray.length > 1 && pathArray[1].length > 0) {
      const query = pathArray.length > 1 ? window.DigitalIdentityHub.utilities.parseQuery(pathArray[1]) : {};
      const queryKeys = Object.keys(query);
      const currentQuery = window.DigitalIdentityHub.utilities.parseQuery(window.location.search.replace("?", ""));

      const queryFiltered = queryKeys.filter(queryKey => currentQuery[queryKey] && currentQuery[queryKey] === query[queryKey]);

      return queryFiltered.length === queryKeys.length;
    }

    return true;
  }

  public showEvents() {
    if (window.console?.log) {
      for (const janrainEvent in janrain.events) {
        try {
          janrain.events[janrainEvent].addHandler(
            function(this: string, result: IJanrainEventResult) {
              console.log(this, result);
            }.bind(janrainEvent)
          );
        } catch { /* No functionality */ }
      }
    }
  }

  public showFlowVersion(elementId: string, result: IJanrainEventResult) {
    const elem = document.getElementById(elementId);
    if (elem) {
      elem.innerText = "Flow version: " + result.version;
    }
  }

  public getCookie(name: string) {
    const nameEQ = name + "=";
    const cookies = document.cookie.split(";");
    for (const element of cookies) {
      let c = element;
      while (c.charAt(0) === " ") {
        c = c.substring(1, c.length);
      }
      if (c.indexOf(nameEQ) === 0) {
        return c.substring(nameEQ.length, c.length);
      }
    }
    return null;
  }

  // USE LanguageSelector module
  public getLanguage(defaultLanguage) {
    // try to find language in cookie
    let desiredLanguage = window.DigitalIdentityHub.utilities.getCookie("language");
    if (!desiredLanguage) {
      // try to find language in localStorage
      desiredLanguage = localStorage.getItem("DigitalIdentityHub-language");
    }
    if (!desiredLanguage) {
      // fallback to cookie
      desiredLanguage = defaultLanguage;
    }
    return desiredLanguage;
  }

  // USE LanguageSelector module
  public setLanguage(requestedLanguage: string) {
    janrain.settings.language = requestedLanguage;

    document.cookie = "language=" + requestedLanguage + "; path=/";
    localStorage.setItem("DigitalIdentityHub-language", requestedLanguage);

    const translations = window.DigitalIdentityHub.translations[requestedLanguage];

    if (translations) {
      Array.from(document.querySelectorAll("[data-translate-content]")).forEach(i => {
        if (i instanceof HTMLElement && translations[i.innerText.trim()]) {
          i.innerHTML = translations[i.innerText.trim()];
        } else if (i instanceof HTMLElement) {
          translations[i.innerText.trim()] = i.innerHTML;
        }
      });
      Array.from(document.querySelectorAll("[data-translate-value]")).forEach(i => {
        if (i instanceof HTMLInputElement && translations[i.value.trim()]) {
          i.value = translations[i.value.trim()];
        } else if (i instanceof HTMLInputElement) {
          translations[i.value.trim()] = i.value.trim();
        }
      });
      Array.from(document.querySelectorAll("[data-translate-placeholder]")).forEach(i => {
        if (i instanceof HTMLInputElement && translations[i.placeholder.trim()]) {
          i.placeholder = translations[i.placeholder.trim()];
        } else if (i instanceof HTMLInputElement) {
          translations[i.placeholder.trim()] = i.placeholder.trim();
        }
      });
    }
  }

  public translate(sentence: string) {
    return window.DigitalIdentityHub.translations[janrain.settings.language][sentence] || sentence;
  }

  public injectScript(url: string) {
    const injector = document.createElement("script");
    injector.type = "text/javascript";
    injector.src = url;
    const firstScript = document.getElementsByTagName("script")[0];
    firstScript.parentNode.insertBefore(injector, firstScript);
    return injector;
  }

  public isUnique(form: string, field: string, value: string): Promise<boolean> {
    return new Promise(resolve => {
      const endpoint = janrain.settings.capture.captureServer + "/widget/unique.jsonp";
      const originalHandler = janrain.capture.ui.handleCaptureUniqueResponse;
      const newHandler = function(result) {
        janrain.capture.ui.handleCaptureUniqueResponse = originalHandler;
        return resolve(result.result.unique);
      };
      janrain.capture.ui.handleCaptureUniqueResponse = newHandler;

      const url = new URL(endpoint);
      url.searchParams.set("js_version", (document.getElementsByName("js_version").item(0) as HTMLInputElement).value);
      url.searchParams.set("capture_screen", janrain.settings.capture.currentScreenName);
      url.searchParams.set("flow", janrain.settings.capture.flowName);
      url.searchParams.set("client_id", janrain.settings.capture.clientId);
      url.searchParams.set("redirect_uri", janrain.settings.capture.redirectUri);
      url.searchParams.set("response_type", janrain.settings.capture.responseType);
      url.searchParams.set("flow_version", janrain.settings.capture.flowVersionNumber);
      url.searchParams.set("settings_version", "null");
      url.searchParams.set("locale", janrain.settings.language);
      url.searchParams.set("value", value);
      url.searchParams.set("form", form);
      url.searchParams.set("field", field);

      this.injectScript(url.toString());
    });
  }

  public getCountryCode() {
    return janrain.settings.capture.federateSegment === "XX" ? "AU" : janrain.settings.capture.federateSegment;
  }

  public addScript(path: string, async = true) {
    const js = document.createElement("script");
    js.src = path;
    js.async = async;
    document.head.appendChild(js);
  }

  public addLink(path: string, type: string, rel: string) {
    const css = document.createElement("link");
    css.rel = rel;
    css.type = type;
    css.href = path;
    document.head.appendChild(css);
  }

  public registerValidation(name: string, test: (name: string, value: string) => boolean) {
    janrain.capture.ui.registerFunction(name, test);
    window.DigitalIdentityHub.validations[name] = test;
  }

  public removeNulls(obj: object): object {
    return Object.keys(obj).reduce((acc, key) => {
      if (obj[key]) {
        acc[key] = obj[key];
      }
      return acc;
    }, {});
  }

  public removeClass(element, className) {
    element.className = element.className
      .replace(className, "")
      .replace("  ", " ")
      .trim();
  }

  public addClass(element, classname) {
    const classes = element.className;
    if (classes.indexOf(classname) !== -1) {
      return;
    }

    element.className = classes === "" ? classname : `${classes} ${classname}`;
  }

  public isSafari() {
    const ua = navigator.userAgent.toLowerCase();
    return ua.indexOf("safari/") > -1 && ua.indexOf("chrome/") === -1 && ua.indexOf("chromium/") === -1;
  }

  public isUrl(url) {
    // eslint-disable-next-line no-useless-escape
    const test = /^([a-z][a-z0-9*\-.]*):\/\/(?:(?:(?:[\w.\-+!$&'()*+,;=]|%[0-9a-f]{2})+:)*(?:[\w.\-+%!$&'()*+,;=]|%[0-9a-f]{2})+@)?(?:(?:[a-z0-9\-.]|%[0-9a-f]{2})+|(?:\[(?:[0-9a-f]{0,4}:)*(?:[0-9a-f]{0,4})]))(?::[0-9]+)?(?:[/|?](?:[\w#!:.?+=&@!$'~*,;/()\[\]-]|%[0-9a-f]{2})*)?$/.test(url);
    // URL regex from https://mathiasbynens.be/demo/url-regex
    return test;
  }
}
